var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('ContextView',{attrs:{"visible":_vm.contextViewVisible}}),(!_vm.languageIsChanging)?_c('router-view',{key:"$route.fullPath"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }